/**
 * Type definitions for Create Listing wizard
 * Based on: srcLegacy/shared/containers/CreateListingPage/
 */

import type { GetUserPropertyDetailsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { WizardStepType } from '../WizardStepController/types';

// Flow types (based on legacy constants and flow variants)
export enum FlowType {
  STANDARD = 'standard',
  CONDENSED = 'condensed',
  AI_LISTING_CREATION_TEST_B = 'ai-listing-creation-test-b',
  RELISTING = 'relisting',
  RELISTING_TOUR = 'relisting-tour',
  MULTIPLEX = 'multiplex',
  ROOM_FOR_RENT_RYAN = 'room-for-rent-ryan',
  ROOM_FOR_RENT_IRENE = 'room-for-rent-irene',
}

// Feature flags that affect wizard flow
export type FeatureFlags = {
  canAccessMultiplexListingFlow: boolean;
  canAccessRelistingFlow: boolean;
  canAccessFastPost: boolean;
  canAccessMLReactivationFlow: boolean;
  canAccessPostingPathTourScheduling: boolean;
  canAccessSFCostsAndFees: boolean;
  canAccessScreeningCriteria: boolean;
  canAccessCondensedFlow: boolean;
  canAccessAIListingCreationTestB: boolean;
  canAccessTotalMonthlyPriceWithFee: boolean;
  /** Rollout flag AND the server saying this listing still needs verification. */
  canAccessOwnershipVerification: boolean;
};

// Property restrictions that affect step visibility
export type PropertyRestrictions = {
  isApplicationsUpdateRestricted: boolean;
  isHidePhoneRestricted: boolean;
};

// User selections made during the wizard flow
export type UserSelections = {
  tourBookingMethod?: string;
};

// Complete wizard context
export type WizardContext = {
  flowType: FlowType;
  property: GetUserPropertyDetailsResponseWebDto;
  flags: FeatureFlags;
  restrictions: PropertyRestrictions;
  userSelections: UserSelections;
};

// Extended step config with visibility logic
export type StepConfig = WizardStepType & {
  shouldRender: (property: GetUserPropertyDetailsResponseWebDto, flags: FeatureFlags) => boolean;
};
